import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroViajeEAD;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ViajeEADFiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Status = getField(selectores.StatusViajeEAD);
        const Chofer = getField(selectores.ChoferEAD);
        const Camion = getField(selectores.CamionEAD);
        const Sucursal = getField(selectores.Sucursal);
        const Ruta = getField(selectores.RutaEAD);
        const Number = getField(kea.Number);
        const Date = getField(kea.DateTime);

        return (
            <div>
                {kea.autogrid(3, [
                    <Status field="Status" label="Status" />,
                    <Chofer field="IdChofer" label="Chofer" />,
                    <Camion field="IdCamion" label="Camión" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Ruta field="IdRuta" label="Ruta" />,
                    <Number field="Folio" label="Folio" />,
                    <Date field="FechaCreacionInicio" label="Fecha creación (inicio)" />,
                    <Date field="FechaCreacionFinal" label="Fecha creación (final)" />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/list/filtro.tsx